module.exports = "https://99designs-start-assets.imgix.net/js/7f307d916baa20b06c28a9f2735617b5.png";